import { motion } from "framer-motion";
import { User, CalendarClock, MapPin, FileText, ArrowUpRight } from "lucide-react";
import { Reveal, SectionTag } from "@/components/Reveal";

const steps = [
  { icon: User, title: "Select Plumber", text: "Choose your service — and even your preferred tradie." },
  { icon: CalendarClock, title: "Pick day & time", text: "Real live availability. Choose the actual day and time slot." },
  { icon: MapPin, title: "Tell us where", text: "Your name and where to find you. Perth, Rockingham to Joondalup." },
  { icon: FileText, title: "Describe the blockage", text: "A quick job description and we arrive onsite, equipment ready." },
];

export default function Booking() {
  return (
    <section id="booking" data-testid="booking-section" className="border-b-2 border-white/10 py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionTag number="04" label="Book Online In Minutes" color="#adff01" />

        <Reveal>
          <h2 className="max-w-4xl font-display text-4xl uppercase leading-[0.9] tracking-tight sm:text-6xl">
            The only <span className="text-[#adff01]">live booking portal</span> in
            Australia
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="mt-6 max-w-2xl text-base leading-relaxed text-zinc-300 md:text-lg">
          <p data-testid="booking-copy">
            Price online. Book online. Choose the day, the actual time — even the tradesman
            himself. Use our booking portal and we'll arrive onsite with all the equipment
            ready to go.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map(({ icon: Icon, title, text }, i) => (
            <Reveal key={title} delay={i * 0.1}>
              <article
                data-testid={`booking-step-${i + 1}`}
                className="group relative h-full border-2 border-white/10 bg-[#121214] p-7 transition-colors hover:border-[#adff01]"
              >
                <span className="text-outline absolute right-4 top-3 font-display text-5xl opacity-70">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="flex h-12 w-12 items-center justify-center border-2 border-[#adff01] bg-[#adff01]/10 transition-transform group-hover:-translate-y-1">
                  <Icon className="h-6 w-6 text-[#adff01]" strokeWidth={2.5} />
                </span>
                <h3 className="mt-5 font-display text-lg uppercase tracking-tight">{title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-zinc-400">{text}</p>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-12">
          <motion.a
            href="#book-it-in"
            data-testid="booking-portal-button"
            whileHover={{ x: -3, y: -3 }}
            className="shadow-hard-green inline-flex items-center gap-2 border-2 border-black bg-[#ff66c4] px-8 py-5 font-display text-base uppercase tracking-wide text-black transition-shadow hover:shadow-[4px_4px_0_0_#adff01] md:text-lg"
          >
            Open The Live Booking Portal
            <ArrowUpRight className="h-6 w-6" strokeWidth={3} />
          </motion.a>
        </Reveal>
      </div>
    </section>
  );
}
